module.exports = __webpack_public_path__ + "static/img/10.8a57fdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/10.png
// module id = ikbc
// module chunks = 0